import {
  updateFence,
  updateIsShow
} from '../../../../../common/redux/reducer/commonSlices/circleSlice';
import {
  map,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import {
  updateIsShowDrawingManager,
  updatePolygonFences
} from '../../../../../common/redux/reducer/commonSlices/polygonSlice';
import { updateCenter as updateMapCenter } from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import { getGeofenceMappingAction } from '../../../redux/reducer/yaantracSlices/geofenceSlice';
import { convertEpochToStartDateString } from '../../../../../utils/commonFunctions';
import { useState } from 'react';

export const useGeofenceCardView = ({
  setCardOpen,
  dispatch,
  setPageNo,
  setPageSize,
  pageNo,
  pageSize,
  setIsCircular,
  setCardData,
  createAbort,
  setExpanded,
  setRow,
  mapData
}: any) => {
  const onView = async (params: any) => {
    setPageNo(1);
    setPageSize(5);
    setExpanded(false);
    setCardData(params);
    await dispatch(
      getGeofenceMappingAction({
        geoZoneId: params?.geoZoneId,
        pageNo: pageNo,
        pageSize: pageSize,
        signal: createAbort().abortCall.signal
      })
    );
    setRow((prev: any) => {
      let activeRow = prev?.map((value: any, currentIndex: number) => ({
        ...value,
        activeColor: value?.geoZoneId === params?.geoZoneId ? true : false
      }));
      return activeRow;
    });
    const filteredVehicle = mapData?.data?.filter((vehicle: any) =>
      params?.vehicleNumber?.includes(vehicle.id)
    );
    dispatch(map(filteredVehicle));
    let { radius, latAndLongDetails } = params;
    dispatch(updateIsShowDrawingManager(false));

    dispatch(updateIsShow(true));

    if (params?.geoType === 'polygon') {
      setIsCircular(false);
      dispatch(
        updatePolygonFences([{ id: params?.geoZoneId, paths: latAndLongDetails }])
      );
      dispatch(updateFence([]));
      if (filteredVehicle?.length === 0) {
        dispatch(updateZoom(latAndLongDetails));
        dispatch(updateMapCenter(latAndLongDetails));
      } else {
        dispatch(updateMapCenter([...latAndLongDetails, ...filteredVehicle]));
        dispatch(updateZoom([...latAndLongDetails, ...filteredVehicle]));
      }
    } else if (params?.geoType === 'circular') {
      let newRadius = radius + radius / 2;
      let scale = newRadius / 500;
      let zoom = 5 - Math.log(scale) / Math.log(2);
      dispatch(
        updateFence([
          {
            id: params?.geoZoneId,
            center: params?.latAndLongDetails?.[0],
            radius: params?.radius * 1000
          }
        ])
      );

      if (filteredVehicle?.length === 0) {
        dispatch(updateZoom(zoom));
        dispatch(updateMapCenter(latAndLongDetails));
      } else {
        dispatch(updateMapCenter([...latAndLongDetails, ...filteredVehicle]));
        dispatch(updateZoom([...latAndLongDetails, ...filteredVehicle]));
      }

      dispatch(updatePolygonFences([]));
      setIsCircular(true);
    }
    setCardOpen(true);
  };
  return { onView };
};

export const useGeofenceSummary = ({
  cardData,
  geofencemapping,
  setExpanded,
  expanded,
  setCardOpen,
  setRow,
  dispatch
}: any) => {
  const [viewEye, setViewEye] = useState<boolean>(false);

  const handleViewEye = () => {
    if (cardData?.vehicleNumber?.length > 0) {
      setViewEye(true);
    }
  };

  const handleExpandClick = () => setExpanded(!expanded);

  const closeCardIcon = () => {
    setCardOpen(false);
    setRow((prev: any) => {
      const inactiveRows = prev?.map((item: any) => ({
        ...item,
        activeColor: false
      }));
      return inactiveRows;
    });
    dispatch(map([]));
  };

  const handleViewVehicle = async (params: any) => {
    const { latAndLongDetails } = cardData;
    const vehicleLocation = {
      lat: Number(params?.row?.latitude),
      lng: Number(params?.row?.longitude)
    };

    dispatch(updateZoom([...latAndLongDetails, vehicleLocation]));
    dispatch(updateMapCenter([...latAndLongDetails, vehicleLocation]));
    const fenceStatus: any = {
      OUT: 'Fence Out',
      IN: 'Fence In'
    };

    const filteredVehicle = {
      id: params?.row?.vehicleNumber?.toUpperCase(),
      name: 'location',
      type: 'car',
      lat: parseFloat(params?.row?.latitude),
      lng: parseFloat(params?.row?.longitude),
      status: fenceStatus[params?.row?.status],
      info: {
        'Vehicle No.': params?.row?.vehicleNumber,
        status: fenceStatus[params?.row?.status],
        'Date & Time': params?.row?.timeStamp
      }
    };
    dispatch(map([filteredVehicle]));
  };

  const geofenceMappingList = geofencemapping
    ? geofencemapping?.map((value: any, index: number) => ({
        id: index,
        vehicleNumber: (value?.vehicleNumber).toUpperCase(),
        status: value?.status,
        timeStamp: convertEpochToStartDateString(value?.inTimeStamp),
        latitude: value?.latitude,
        longitude: value?.longitude
      }))
    : [];

  return {
    viewEye,
    setViewEye,
    handleViewEye,
    geofenceMappingList,
    handleExpandClick,
    closeCardIcon,
    handleViewVehicle
  };
};
